"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddProduct = void 0;
const class_validator_1 = require("class-validator");
const common_1 = require("../../common");
class AddProduct extends common_1.BaseAction {
}
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsNotEmpty()
], AddProduct.prototype, "productCode", void 0);
__decorate([
    class_validator_1.IsMongoId()
], AddProduct.prototype, "manufacturerId", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], AddProduct.prototype, "description", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], AddProduct.prototype, "revision", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsNotEmpty()
], AddProduct.prototype, "umCode", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsNumber(),
    class_validator_1.Min(0)
], AddProduct.prototype, "standardPrice", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], AddProduct.prototype, "productPage", void 0);
__decorate([
    class_validator_1.IsBoolean(),
    class_validator_1.IsOptional()
], AddProduct.prototype, "assembly", void 0);
exports.AddProduct = AddProduct;
//# sourceMappingURL=add-product.action.js.map